import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyBseJ2l2zcWFlmAv5YFHzHpuu2-mlYzc9Q",
  authDomain: "typt-82327.firebaseapp.com",
  databaseURL: "https://typt-82327.firebaseio.com",
  projectId: "typt-82327",
  storageBucket: "typt-82327.appspot.com",
  messagingSenderId: "122466000713"
};

firebase.initializeApp(config);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

// Export types that exists in Firestore
const { TimeStamp, GeoPoint, FieldValue } = firebase.firestore;

Vue.use({
  install(Vue) {
    Vue.prototype.$f = {
      auth,
      db,
      storage,
      TimeStamp,
      GeoPoint,
      FieldValue
    };
  }
});
